export { default } from './FaqLPs25';
